import { useProfile } from "@/hooks/useProfile";

function timeOfDay(hours: number): string {
  if (hours >= 4 && hours <= 11) return "Morning";
  if (hours >= 12 && hours <= 16) return "Afternoon";
  if (hours >= 17 && hours <= 20) return "Evening";
  return "Tonight";
}

export function Greeting() {
  const { data: profile } = useProfile();
  const name = profile?.display_name?.trim() || "gardener";
  const now = new Date();
  const label = timeOfDay(now.getHours());
  const dateLabel = new Intl.DateTimeFormat("en-US", {
    weekday: "long",
    month: "long",
    day: "numeric",
  }).format(now);

  return (
    <section data-testid="greeting" className="pt-2">
      <h1
        className="font-display text-3xl leading-tight"
        style={{ color: "#1A1620" }}
      >
        {label}, {name}
      </h1>
      <p className="mt-1 text-sm" style={{ color: "#9A8A78" }}>
        {dateLabel}
      </p>
    </section>
  );
}
